import { ApiKey } from "../types/api";

const API_BASE_URL = "/api/v1"; // Always use relative URL to work with both dev proxy and production rewrites

export const apiService = {
  async fetchKeys(token: string): Promise<ApiKey[]> {
    const response = await fetch(`${API_BASE_URL}/keys`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch API keys");
    }

    return response.json();
  },

  async createKey(token: string, name: string): Promise<{ key: string }> {
    const response = await fetch(`${API_BASE_URL}/key`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name }),
    });

    if (!response.ok) {
      throw new Error("Failed to create API key");
    }

    return response.json();
  },

  async deleteKey(token: string, keyId: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/key/${keyId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete API key");
    }
  },
};
